// SHADOW MARKET™ — 3D Customization Page.
// Route: /shadow-market/personalizar/:slug  (polos & camisetas only)
// Thin wrapper around Studio3DClient (which contains the full UI).
import React, { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Studio3DClient } from "../components/Studio3DClient";
import { getProductBySlug } from "../data/shop-products";
import { useLanguage } from "../i18n/LanguageContext";
import { useShopI18n } from "../i18n/shop";
import "./shadow-market.css";

const CUSTOMIZABLE_TYPES = new Set(["polo", "camiseta"]);

const ShadowMarketCustomizePage = () => {
  const { slug } = useParams();
  const product = getProductBySlug(slug);
  const { lang } = useLanguage();
  const t = useShopI18n(lang);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!product) {
    return <Navigate to="/shadow-market" replace />;
  }
  if (!CUSTOMIZABLE_TYPES.has(product.type)) {
    return <Navigate to={`/shadow-market/${product.slug}`} replace />;
  }

  return (
    <div
      className="shop-root min-h-screen bg-black text-white antialiased"
      data-testid="shadow-market-customize-page"
    >
      <Navbar />
      <div style={{ height: 96 }} />

      {/* Breadcrumb */}
      <div
        style={{
          background: "#0a0b14",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
          padding: "10px 24px",
          fontFamily: "'Courier New', monospace",
          fontSize: "0.65rem",
          color: "rgba(255,255,255,0.3)",
          letterSpacing: "0.1em",
        }}
      >
        <Link
          to="/shadow-market"
          style={{ color: "rgba(255,255,255,0.3)", textDecoration: "none" }}
        >
          SHADOW MARKET™
        </Link>
        {" → "}
        <span className="breadcrumb-middle">
          <Link
            to={`/shadow-market/${product.slug}`}
            style={{ color: "rgba(255,255,255,0.3)", textDecoration: "none" }}
          >
            {product.name}
          </Link>
          {" → "}
        </span>
        <span style={{ color: "#f5a623" }}>{t.customize_cta}</span>
      </div>

      <main style={{ background: "#07080f", minHeight: "calc(100vh - 96px)" }}>
        <Studio3DClient product={product} />
      </main>
    </div>
  );
};

export default ShadowMarketCustomizePage;
